<template>
    <div :style="{
        '--divWidth--': divWidth,
        '--divHeight--': divHeight,
        position: IsBigDiv ? 'fixed' : 'static'
    }"
        style="width: var(--divWidth--);height: var(--divHeight--);top: 0;left: 0;z-index: 1000 !important;background-color: white;
      background-image: url('https://aitwo.eos-shanghai-2.cmecloud.cn/AiTrainingFile/bigScreen.jpg');background-repeat:no-repeat;background-size: var(--divWidth--)  var(--divHeight--);overflow: hidden;">
        <div @dblclick="BigScreen" style="margin: 1% auto 0; width: 50%;font-size: 1.875rem;text-align: center;font-weight: 800;
          color: white;">
            Ai智能场景演练
        </div>
        <div style="width: 100%;height: 88%;display: flex;justify-content: space-around;margin-top: 1.5%;">
            <div style="width: 28%;height: 100%;">
                <dv-border-box-11 ref="box5" style="width: 100%;height: 100%;" title="场景演练分数排行榜" :key="5">
                    <div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
                        <div style="width: 92%;height: 90%;margin-top: 8%;border-radius: 3%;overflow: auto;">
                            <template v-for="(item, index) in BigScreenData.rankScoreList || []">
                                <div
                                    style="width: 100%;height: 9.5%;display: flex;align-items: center;justify-content: space-around;background-color: rgba(38,81,207, 0.2);margin-top: 1%;overflow: hidden;">
                                    <div style="width: 4rem;height: 4rem;">
                                        <el-image style="width: 100%;height: 100%;border-radius: 100%;"
                                            :src="item.userHeader" />
                                    </div>
                                    <div
                                        style="width: calc(100% - 14rem);height: 100%;display: flex;justify-content: center;flex-direction: column;">
                                        <div
                                            style="font-size: 1.1rem;font-weight: 600;color: white;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                            {{ item.userName }}
                                        </div>
                                        <div
                                            style="font-size: 1rem;color: white;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                            {{ item.dtName }}
                                        </div>
                                    </div>
                                    <div
                                        style="width: 5rem;height: 100%;display: flex;justify-content: center;font-size: 0.9rem;color: white;flex-direction: column;">
                                        <div>
                                            分数<span
                                                style="margin-left: 0.5rem;font-size: 1.2rem;color: #67C23A;font-weight: 800;">{{
                                                    item.matchRank }}</span>
                                        </div>
                                        <div>
                                            排名<span
                                                style="margin-left: 0.5rem;font-size: 1.2rem;color: #67C23A;font-weight: 800;">{{
                                                    item.userPosition }}</span>
                                        </div>

                                    </div>
                                </div>

                            </template>
                        </div>
                    </div>
                </dv-border-box-11>
            </div>
            <div style="width: 40%;height: 100%;">
                <dv-border-box-11 ref="box8" class="box8" style="width: 100%;height: 40%;display: flex;" title="完成情况"
                    :key="8">
                    <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
                        <div
                            style="width: 40%;height: 70%;display: flex;justify-content: center;flex-direction: column;">
                            <div style="font-size: 2rem;font-weight:800;color: white;text-align: center;">
                                项目总人数
                            </div>
                            <div
                                style="font-size: 2.6rem;font-weight:800;color: #409EFF;text-align: center;margin-top: 6%;">
                                {{ BigScreenData.projectUserNums || '0' }}
                            </div>
                        </div>
                        <div
                            style="width: 40%;height: 70%;display: flex;justify-content: center;flex-direction: column;">
                            <div style="font-size: 2rem;font-weight:800;color: white;text-align: center;">
                                已完成人数
                            </div>
                            <div
                                style="font-size: 2.6rem;font-weight:800;color: #67C23A;text-align: center;margin-top: 6%;">
                                {{ BigScreenData.projectCompleteNums || '0' }}
                            </div>
                        </div>
                    </div>
                </dv-border-box-11>
                <div style="width: 100%;height: 57%;;margin-top: 2%;">
                    <dv-border-box-10 ref="box4" style="width: 100%;height: 100%;" :key="4">
                        <div
                            style="height: 3rem;font-weight: 600;font-size: 1.5rem;color: #409EFF;width: 100%;text-align: center;">
                            最新完成展示
                        </div>
                        <dv-scroll-board :config="config" ref="scrollBoard"
                            style="width:95%;height:calc(97% - 3rem);margin: 0 2.5%;" />
                    </dv-border-box-10>
                </div>
            </div>
            <div style="width: 28%;height: 100%">
                <dv-border-box-11 ref="box6" style="width: 100%;height: 100%;" title="场景演练次数排行榜" :key="6">
                    <div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
                        <div style="width: 92%;height: 90%;margin-top: 8%;border-radius: 3%;overflow: auto;">
                            <template v-for="(item, index) in BigScreenData.rankNumList || []">
                                <div
                                    style="width: 100%;height: 9.5%;display: flex;align-items: center;justify-content: space-around;background-color: rgba(38,81,207, 0.2);margin-top: 1%;overflow: hidden;">
                                    <div style="width: 4rem;height: 4rem;">
                                        <el-image style="width: 100%;height: 100%;border-radius: 100%;"
                                            :src="item.userHeader" />
                                    </div>
                                    <div
                                        style="width: calc(100% - 14rem);height: 100%;display: flex;justify-content: center;flex-direction: column;">
                                        <div
                                            style="font-size: 1.1rem;font-weight: 600;color: white;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                            {{ item.userName }}
                                        </div>
                                        <div
                                            style="font-size: 1rem;color: white;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                            {{ item.dtName }}
                                        </div>
                                    </div>
                                    <div
                                        style="width: 5rem;height: 100%;display: flex;justify-content: center;font-size: 0.9rem;color: white;flex-direction: column;">
                                        <div>
                                            次数<span
                                                style="margin-left: 0.5rem;font-size: 1.2rem;color: #F56C6C;font-weight: 800;">{{
                                                    item.numRank }}</span>
                                        </div>
                                        <div>
                                            排名<span
                                                style="margin-left: 0.5rem;font-size: 1.2rem;color: #F56C6C;font-weight: 800;">{{
                                                    item.userPosition }}</span>
                                        </div>

                                    </div>
                                </div>

                            </template>
                        </div>
                    </div>
                </dv-border-box-11>
            </div>

        </div>
    </div>
</template>

<script>
import { getAiTrainLargeScreen } from "../api/api";
import echarts from "echarts";
export default {
    name: "BigSceen",
    components: {},
    data() {
        let this_ = this;
        return {

            BigScreenData: [],
            color: [
                " #4992ff",
                " #dd79ff",
                " #fddd60",
                "  #ff6e76",
                " #58d9f9",
                " #05c091",
                "  #ff8a45",
                " #8d48e3"
            ],
            Statistics_data: {},
            theUserProject: null,
            divWidth: "100%",
            divHeight: "100%",
            IsBigDiv: true,
            config: {
                header: ['学员', '演练场景', '最终得分'],
                data: [],
                columnWidth:['100','550','100'],
                align: ['center','center','center'],
                oddRowBGC: "none",
                evenRowBGC: "rgba(38,81,207, 0.3)"
            }
        };
    },
    watch: {
        divWidth(n, v) {
            console.log(n);
            setTimeout(() => {
                this.$refs["scrollBoard"].updateRows(this.config.data);
                this.$refs.box4.initWH();
                this.$refs.box5.initWH();
                this.$refs.box6.initWH();
                this.$refs.box8.initWH();
            }, 300);
        }
    },
    async created() {
        getAiTrainLargeScreen().then(res => {
            const config_data = [];
            res.data.ycAiTrainUserListLasted.forEach((item, index) => {
                const data = [`
                            <div class="usersty scrollboard">
                               ${item.createusername}
                            </div>`,
                `<div class="usersty scrollboard">
                               ${item.yatbTitle}
                            </div>`,
                `<div class="usersty scrollboard">
                                ${item.yatuScore}分
                            </div>`
                ]
                config_data.push(data);
            });
            this.config.data = config_data;
            this.BigScreenData = res.data;
            this.$refs["scrollBoard"].updateRows(this.config.data);
        })
        var timer = setInterval(() => {
            setTimeout(() => {
                ///调取接口
                getAiTrainLargeScreen().then(res => {
                    const config_data = [];
                    res.data.ycAiTrainUserListLasted.forEach((item, index) => {
                        const data = [`
                            <div class="usersty scrollboard">
                               ${item.createusername}
                            </div>`,
                        `<div class="usersty scrollboard">
                               ${item.yatbTitle}
                            </div>`,
                        `<div class="usersty scrollboard">
                                ${item.yatuScore}分
                            </div>`
                        ]
                        config_data.push(data);
                    });
                    this.config.data = config_data;
                    this.BigScreenData = res.data;
                    this.$refs["scrollBoard"].updateRows(this.config.data);
                })

            }, 0);
        }, 5 * 60000);
    },
    mounted() {
        setTimeout(() => {
            this.$refs["scrollBoard"].updateRows(this.config.data);
            this.$refs.box4.initWH();
            this.$refs.box5.initWH();
            this.$refs.box6.initWH();
            this.$refs.box8.initWH();
        }, 100);
        const _this = this;
        window.addEventListener("resize", function () {
            console.log("改变了");
            setTimeout(() => {
                _this.$refs["scrollBoard"].updateRows(_this.config.data);
                _this.$refs.box4.initWH();
                _this.$refs.box5.initWH();
                _this.$refs.box6.initWH();
                _this.$refs.box8.initWH();
            }, 100);
        });
    },

    methods: {
        // 图标配置项
        DrawEcharts() {
            var that = this;

        },
        async getEchartsValue() {


        },

        BigScreen() {
            this.IsBigDiv = !this.IsBigDiv;
            if (this.IsBigDiv) {
                this.divHeight = "100vh";
                this.divWidth = "100vw";
            } else {
                this.divHeight = "100%";
                this.divWidth = "100%";
            }
        },

        //  换算方法
        nowSize(val, initWidth = 1920) {
            //当前视口宽度
            let nowClientWidth = document.documentElement.clientWidth;

            return val * (nowClientWidth / initWidth);
        },

        fmoney(s, n = 2) {
            n = n > 0 && n <= 20 ? n : 2;
            s = parseFloat((s + "").replace(/[^\d.-]/g, "")).toFixed(n) + "";
            let m = Number(JSON.parse(s)); // 深拷贝数据并转换为number类型
            let num = "";
            let w = ""; // 单位
            let l = s
                .split(".")[0]
                .split("")
                .reverse();
            if (l.length >= 13) {
                num = (m / 1000000000000).toFixed(n);
                w = "万亿";
            } else if (l.length >= 9) {
                num = (m / 100000000).toFixed(n);
                w = "亿";
            } else if (l.length >= 5) {
                num = (m / 10000).toFixed(n);
                w = "万";
            } else {
                num = m.toFixed(n);
                w = "";
            }
            num = parseFloat((num + "").replace(/[^\d.-]/g, "")).toFixed(n) + "";
            let gg = num
                .split(".")[0]
                .split("")
                .reverse();
            let r = num.split(".")[1] === "00" ? "" : "." + num.split(".")[1];
            let t = "";
            if (gg[gg.length - 1] === "-") {
                let index = gg.findIndex(item => item === "-");
                gg.splice(index, 1);
                for (let i = 0; i < gg.length; i++) {
                    t += gg[i] + ((i + 1) % 3 == 0 && i + 1 != gg.length ? "," : "");
                }
                t += "-";
            } else {
                for (let i = 0; i < gg.length; i++) {
                    t += gg[i] + ((i + 1) % 3 == 0 && i + 1 != gg.length ? "," : "");
                }
            }
            return (
                t
                    .split("")
                    .reverse()
                    .join("") +
                r +
                w
            );
        }
    }
};
</script>

<style scoped>
div::-webkit-scrollbar {
    display: none !important;
}

.flex /deep/ #Myrouterview {
    padding: 0 !important;
    max-height: none !important;
}

.divTitle {
    color: #d6d7dd;
    font-size: 0.9rem;
    margin-left: 0.3125rem;
    width: 45%;
}

.spanText {
    color: white;
    font-weight: 600;
    font-size: 1.35rem;
}

.spanTextOther {
    color: white;
    font-weight: 400;
    font-size: 0.9375rem;
}

.usersty {
    width: 100%;
    font-size: 1rem;
    color: white;
    text-align: center !important;
}

.scrollboard {
    background-color: rgba(38, 81, 207, 0.6);
    border-radius: 1.5%;
    /* width: 100%; */
    padding: 0.5rem 1rem;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>